//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";

export default {
  name: "SectionExcursionTopTitle",
  components: {
    Icon24FillFavorites: () => import('@/assets/icons/Icon24FillFavorites.svg?inline'),
    Icon24FillDistance: () => import('@/assets/icons/Icon24FillDistance.svg?inline'),
    RoundButton: () => import('@/components/common/RoundButton'),
    Hint: () => import('@/components/common/Hint/index'),
    TopTitleComponent: () => import('@/components/common/TopTitleComponent'),
    Section: () => import('@/components/common/Section/index')
  },
  data() {
    return {
      hideHint: false,
      innerFavorited: false,
    }
  },
  computed: {
    ...mapGetters({
      logged: 'user/logged',
      travels: 'travels/travels',
      innerTravels: 'travels/innerTravels',
      id: 'excursion/id',
      title: 'excursion/title',
      entity: 'excursion/entity',
      favorited: 'excursion/favorited',
      userTravels: 'excursion/userTravels',
      toasterOpen: "toasters/opened"
    }),
    travelId() {
      return this?.travels[0]?.id
    },
    roundButtonSize() {
      switch (this?.$media()) {
        case 'sm': {
          return '36px'
        }
        default: {
          return '48px'
        }
      }
    },
  },
  async mounted() {
    if (this.logged) {
      await this.$store.dispatch('travels/fetch', {
        params: {
          lang: this.$i18n.locale
        }
      })
    }
    this.innerFavorited = this.favorited
    this.$store.commit('travels/setInnerTravels', !!this.userTravels[0]?.id)
  },
  methods: {
    toggleTravel() {
      if (this.logged) {
        if (this.innerTravels) {
          this.hideHint = true
        }
        this.travels.length > 0
          ? this.addAndRemoveTravel()
          : this.openPopupAddTravel()
      } else {
        this.$login()
      }
    },
    addAndRemoveTravel() {
      if (this.innerTravels) {
        this.$axios.$post(`api/excursions/${this.id}/travels/${this.travelId}/remove`)
          .then(() => this.$store.commit('travels/setInnerTravels', false))
      } else {
        this.$axios.$post(`api/excursions/${this.id}/travels/${this.travelId}/add`)
          .then(() => this.$store.commit('travels/setInnerTravels', true))
          .catch((error) => {
            if (!this.toasterOpen) {
              // Первично задает данные для обертки тостера
              this.$store.commit("toasters/open", {
                params: {
                  position: {
                    vertical: "bottom",
                    horizontal: "right"
                  },
                  size: {
                    maxWidth: "400px",
                  }
                },
              });
            }
            this.$store.commit("toasters/setToasters", {
              id: this.$randomString(),
              status: 'danger',
              componentInfo: {
                componentName: "ToasterText",
                props: {
                  text: error?.response?.data?.message
                }
              }
            });
          });
      }
    },
    openPopupAddTravel() {
      this.$store.commit('popup/open', {
        name: 'PopupAddTravel',
        params: {
          style: {
            width: '100%',
            maxWidth: '632px',
            maxHeight: '100vh',
            overflow: 'visible',
            position: 'relative',
            overflowY: 'visible',
            overflowX: 'visible'
          },
          objectId: this.id,
          entity: this.entity
        }
      })
    },
    toggleFavorite() {
      if (this.logged) {
        this.$axios.$post(`/api/${this?.entity}/${this?.id}/favorites`)
          .then(() => {
            this.innerFavorited = !this.innerFavorited
          })
      } else {
        this.$login()
      }
    },
  }
};
